module.exports = __webpack_public_path__ + "img/speaker-JodyAvirgan-imgs.92e6f017.png";